import React from 'react';
import ReactDOM from 'react-dom/client';
import VideoToSignLanguage from './VideoToSignLanguage.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<VideoToSignLanguage />);